import { ref } from 'vue'

const GetGuides = () => {

  const loadedGuides = ref([])
  const guides_error = ref(null)

  const load_guides = async () => {
    try {
      let apiUrl = 'https://dashboard.imslearn.org/api/guides';
      const queryParams = [];
      let perPage = 60;
      let table_name = null;
      // TODO see if we need to use parameters like in courses
      queryParams.push(`perPage=${perPage}`);
      // queryParams.push('table=courses');
      if (table_name !== null) {
        queryParams.push(`table=${table_name}`);
      }
      
      if (queryParams.length > 0) {
        apiUrl += `?${queryParams.join('&')}`;
      }
    
      let data = await fetch(apiUrl)
      if (!data.ok) {
        throw Error('no available guides')
      }
       await data.json().then((res) => {
        
        if (res.success && (res.data !=null) && Array.isArray(res.data) && (res.data.length>0) ) {
          console.log("API response for guides:", res);
          loadedGuides.value = res.data
        }else{
          console.log('unable to load data')
          console.log(res) // todo check with zeina what where is the error message in response res.error ?
          throw Error("No guides found. Try a different search term?")
        }
      })
    }
    catch (err) {
      console.log("Error loading guides:", err);
      guides_error.value = err.message
    }
  }

  return { loadedGuides, guides_error, load_guides }
}

export default GetGuides